export default __webpack_public_path__ + "static/media/profile6.ed1cb5bd.png";